"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AppMenuDropdown = void 0;
const tslib_1 = require("tslib");
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const classnames_1 = tslib_1.__importDefault(require("classnames"));
const isEmpty_1 = tslib_1.__importDefault(require("lodash/fp/isEmpty"));
const noop_1 = tslib_1.__importDefault(require("lodash/fp/noop"));
const useClickOutside_1 = tslib_1.__importDefault(require("../../hooks/useClickOutside"));
const ToggleButton = (props) => {
    const { title, caret } = props;
    const toggleClassName = (0, classnames_1.default)('ModuleNavigation-dropdown', 'dropdown-toggle justify-content-between', {
        inactive: !caret,
    });
    return ((0, jsx_runtime_1.jsxs)("a", Object.assign({ className: toggleClassName, role: 'button', id: 'basic-nav-dropdown' }, { children: [(0, jsx_runtime_1.jsx)("span", { children: title }), caret && (0, jsx_runtime_1.jsx)("span", { className: 'caret' })] })));
};
const DropdownMenu = (props) => {
    const { children } = props;
    if ((0, isEmpty_1.default)(children)) {
        return null;
    }
    return ((0, jsx_runtime_1.jsx)("ul", Object.assign({ role: 'menu', className: 'dropdown-menu' }, { children: children })));
};
const AppMenuDropdownOpener = (0, react_1.forwardRef)((props, ref) => {
    const { open, children, onDropdownClick } = props;
    return ((0, jsx_runtime_1.jsx)("li", Object.assign({ ref: ref, className: (0, classnames_1.default)('dropdown', { open }), onClick: onDropdownClick }, { children: children })));
});
const AppMenuDropdown = (props) => {
    const { title, caret = false, onToggleAppMenu = noop_1.default, children } = props;
    const [isOpen, setIsOpen] = (0, react_1.useState)(false);
    const wrapperRef = (0, useClickOutside_1.default)(() => setIsOpen(false));
    const handleDropdownClick = () => {
        const newState = !isOpen;
        setIsOpen(newState);
        onToggleAppMenu(newState);
    };
    const openWithChildren = !(0, isEmpty_1.default)(children) && isOpen;
    return ((0, jsx_runtime_1.jsxs)(AppMenuDropdownOpener, Object.assign({ open: openWithChildren, onDropdownClick: handleDropdownClick, ref: wrapperRef }, { children: [(0, jsx_runtime_1.jsx)(ToggleButton, { title: title, caret: caret }), (0, jsx_runtime_1.jsx)(DropdownMenu, { children: children })] })));
};
exports.AppMenuDropdown = AppMenuDropdown;
exports.default = exports.AppMenuDropdown;
